export default {
    products:[],
    branch_offices:[],
    voucherTypes:[],
    documents:[],
    code_branch_office:null,
    params : {
        date: null,
        product_ids : [],
        voucher_type_id : null,
        branch_office_id : null,
        document_id : null,
        type_refactor : "",
    },
}



// WEBPACK FOOTER //
// ./src/modules/rebuild/state.js